 import {
  validateEndDateRange,
  validateStartDateRange,
} from "./SonarHelper";

import {
    FILE_FORMAT,
    SpecialChars,
    EXCEL_UPLOAD_MAX_ERR_MSG,
    EXCEL_FORMAT_ERR,
    FILE_SIZE,
    DUPLICATE_DATA_1,
    DUPLICATE_DATA_2,
    INVALID_CHAR,
    INVALID_CHAR_1,
    INVALID_CHAR_2,
    DUPLICATE_DATA,
    EMPTY_VALUE_1,
    EMPTY_VALUE_2,
    EMPTY_VALUE,
    HEADER_ERR,
    HEADER_ERR_MESSAGE,
    OUTLET_STATUS_ERR,
    OUTLET_STATUS_ERR_MSG_2,
    OUTLET_STATUS_ERR_MSG_1,
    EXCEL_EMPTY_ERR_MSG,
    EXCEL_Template
  } from "../../src/components/OutletGeoCompliance/OGComplianceBulkUpload/BulkUpdateModal.constant";
  
  let specialChars = SpecialChars;
  
  export const getEmptyValues = ({ row, setFileError, resolve, isR20Disable }) => {
    if (
      !row["DT Code"] ||
      !row["Outlet Code"] ||
      !row["Geo-Compliance Check"]
    ) {
      let error = `${EMPTY_VALUE_1} ${row.__rowNum__ + 1}${EMPTY_VALUE_2}`;
      setFileError({ header: EMPTY_VALUE, message: error });
      resolve("invalid");
      return true;
    }

    if (!isR20Disable && row["Geo-Compliance Check"] === "0") {
      if (!row["Start Date"] || !row["End Date"]) {
        setFileError({
          header: EMPTY_VALUE,
          message: `Start Date and End Date are required on row ${
            row.__rowNum__ + 1
          } when Geo-Compliance Check is 0`,
        });
        resolve("invalid");
        return true;
      }
    }

    return false;
  };
  
  export const getInvalidValues = ({ mandatoryValues, row, setFileError, resolve }) => {
    const invalidValues = mandatoryValues.filter(
      (v) =>
        specialChars.includes(v?.toString()[0]) ||
        specialChars.includes(v?.toString()[v?.toString().length - 1])
    );
  
    if (invalidValues.length) {
      let error = `${INVALID_CHAR_1} ${row.__rowNum__ + 1}${INVALID_CHAR_2}`;
      setFileError({ header: INVALID_CHAR, message: error });
      resolve("invalid");
      return true;
    }
    return false;
  };
  
  export const getOutletStatus = ({ row, setFileError, resolve }) => {
    if (
    row["Geo-Compliance Check"] !== '0' && row["Geo-Compliance Check"] !== '1' 
    ) {
      let error = `${OUTLET_STATUS_ERR_MSG_1} ${row.__rowNum__ + 1}${OUTLET_STATUS_ERR_MSG_2}`;
      setFileError({ header: OUTLET_STATUS_ERR, message: error });
      resolve("invalid");
      return true;
    }
    return false;
  };
  
  export const getDuplicates = ({ duplicates, filtered, setFileError, resolve, isR20Disable }) => {
    if (duplicates.length) {
      let error = `${DUPLICATE_DATA_1} ${
        duplicates[0].__rowNum__ + 1
      }${DUPLICATE_DATA_2}`;
      setFileError({ header: DUPLICATE_DATA, message: error });
      resolve("invalid");
    } else {
      for (const row of filtered) {
        let mandatoryRow = { ...row };
        let mandatoryValues = Object.values(mandatoryRow);
  
        const invalidValue = getInvalidValues({
          mandatoryValues,
          row,
          setFileError,
          resolve,
        });
        const emptyValue = getEmptyValues({
          row,
          setFileError,
          resolve,
          isR20Disable
        });
  
        const outletStatusValue = getOutletStatus({
          row,
          setFileError,
          resolve,
        })
  
        let invalidStartDate = false;
        let invalidEndDate = false;

        if (!isR20Disable) {
          invalidStartDate = validateStartDateRange({ row, setFileError, resolve });
          if (invalidStartDate) break;
          invalidEndDate = validateEndDateRange({ row, setFileError, resolve });
          if (invalidEndDate) break;
        }

        if (invalidValue || emptyValue || outletStatusValue || invalidStartDate || invalidEndDate) {
          break;
        }
      }
    }
  };
  
  const checkDuplicateValues = ({ elem, idx, item, index }) => {
    return (
      
        elem["Outlet Code"] === item["Outlet Code"] &&
      idx !== index
    );
  };
  
  
  export const isSameArrays = (arrFirst, arrSecond) => {
    let sortedFirstArr = arrFirst.sort();
    let sortedSecondArr = arrSecond.sort();
    return JSON.stringify(sortedFirstArr) === JSON.stringify(sortedSecondArr);
  };
 
  export const getHeader = (data, isR20Disable) => {
    const header = data.split('\r\n')[0].split(',');
    const oldHeader = ["DT Code", "Outlet Code", "Geo-Compliance Check"];
    const newHeader = ["DT Code", "Outlet Code", "Geo-Compliance Check", "Start Date", "End Date"];

    if (isR20Disable && isSameArrays(header, oldHeader)) return header;
    if (!isR20Disable && isSameArrays(header, newHeader)) return header;

    return false;
  }
  
  export const getFormattedData = (data, isR20Disable) => {
    const excelData = data.split("\r\n");
  
    let FormattedData = excelData
      .map((row, index) => {
        if (index !== 0 && index !== excelData.length - 1) {
          const rowData = row.split(",");
        
        if (isR20Disable) {
          const dtCode = rowData[0];
          const outletCode = rowData[1];
          const geoComplianceCheck = rowData[2];

          if (dtCode || outletCode || geoComplianceCheck) {
            return {
              "DT Code": dtCode,
              "Outlet Code": outletCode,
              "Geo-Compliance Check": geoComplianceCheck,
              __rowNum__: row !== ",,," ? index : "",
            };
          }
        }
        else {
          // NEW FLOW WITH DATES
          const dtCode = rowData[0];
          const outletCode = rowData[1];
          const geoComplianceCheck = rowData[2];
          const startDate = rowData[3];
          const endDate = rowData[4];

          if (dtCode || outletCode || geoComplianceCheck || startDate || endDate) {
            return {
              "DT Code": dtCode,
              "Outlet Code": outletCode,
              "Geo-Compliance Check": geoComplianceCheck,
              "Start Date": startDate,
              "End Date": endDate,
              __rowNum__: index
            };
          }
        }
      }})
      .filter((row) => row !== undefined);
  
    return FormattedData;
  };
  
  export const getEmptyFiles = ({ filtered, setFileError, resolve, isR20Disable, countryCode }) => {
    if (!filtered.length) {
      setFileError({ header: EXCEL_Template, message: EXCEL_EMPTY_ERR_MSG });
      resolve("invalid");
      return true;
    }
      const duplicates =   [...filtered.reduce((map, item) => {
      // If country is PK, key = DT Code + Outlet Code, else key = Outlet Code
      const key = countryCode === "pk" 
        ? `${item['DT Code']}_${item['Outlet Code']}` 
        : item['Outlet Code'];

      map.set(key, [...(map.get(key) || []), item]);
      return map;
    }, new Map())
      .values()] // get grouped arrays
      .filter(list => list.length > 1) // keep duplicates
      .flat(); // return one array
    
      getDuplicates({
        duplicates,
        filtered,
        setFileError,
        resolve,
        isR20Disable
      });
  };
  
  export const ValidateExcel = (file, setFileError, isR20Disable, countryCode) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = reader.result;
  
        let FormattedData = getFormattedData(data, isR20Disable);
  
        const filtered = FormattedData.filter((row) =>
          Object.values(row).some((v) => v !== "")
        );

        getEmptyFiles({ filtered, setFileError, resolve, isR20Disable, countryCode });
  
        const header = getHeader(data, isR20Disable);
        if (!header) {
          setFileError({ header: HEADER_ERR, message: HEADER_ERR_MESSAGE });
          resolve("invalid");
        }

        const fileSize = file.size / 1024 / 1024;
        if (!fileSize || fileSize > 25) {
          setFileError({ header: FILE_SIZE, message: EXCEL_UPLOAD_MAX_ERR_MSG });
          resolve("invalid");
        }

        if (file.name.split(".")[1] !== "csv") {
          setFileError({ header: FILE_FORMAT, message: EXCEL_FORMAT_ERR });
          resolve("invalid");
        }
        resolve("valid");
      };
      reader.onerror = (error) => {
        console.log(error);
        reject(error);
      };
      reader.readAsText(file);
    });
  };
  